import { Component, computed, inject } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { FormControl, NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { from } from 'rxjs';
import { withLatestFrom } from 'rxjs/operators';
import { AuthService } from '../../core/auth';
import { ILogin } from '../../core/model';
import { FooterComponent } from '../layout/footer/footer.component';
import { EnvironmentComponent } from '../environment/environment.component';
import { ChooseThemeComponent } from '../choose-theme.component';
import { EnvironmentStore } from '../environment/environment.store';

@Component({
  selector: 'rb-login',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    FooterComponent,
    EnvironmentComponent,
    TranslatePipe,
    FooterComponent,
    NgOptimizedImage,
    IconField,
    InputIcon,
    ChooseThemeComponent,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  readonly #auth = inject(AuthService);
  readonly appInfo = inject(EnvironmentStore);

  showForgottenPasswordLink = computed(() => this.appInfo.environment()?.isAd !== true);

  loginForm = inject(NonNullableFormBuilder).group({
    username: new FormControl('', { validators: Validators.required, nonNullable: true }),
    password: new FormControl('', { validators: [Validators.required], nonNullable: true }),
  });

  get username() {
    return this.loginForm.get('username') as FormControl<string>;
  }

  get password() {
    return this.loginForm.get('password') as FormControl<string>;
  }

  onSubmit() {
    if (!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    this.loginForm.disable();
    const loginForm: ILogin = {
      username: this.username.value,
      password: this.password.value,
      grantType: 'ACCESS',
    };
    from(this.#auth.loginWithCredentials(loginForm))
      .pipe(withLatestFrom(this.#auth.isUserLoggedIn()))
      .subscribe({
        next: ([, isLoggedIn]) => {
          if (isLoggedIn) {
            this.loginForm.reset();
          }
          this.loginForm.enable();
        },
        error: () => {
          this.loginForm.reset();
          this.loginForm.enable();
        },
      });
  }
}
